function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M497.9,173.8l-223.2-68.6c-12.2-3.7-25.3-3.7-37.4,0L14.1,173.8c-18.8,5.8-18.8,30.7,0,36.5l38.9,12 c-8.5,10.6-13.8,23.4-14.3,37.5c-7.7,4.4-13.1,12.4-13.1,21.9c0,8.6,4.5,15.9,11.1,20.5L16.3,394c-1.8,8,4.3,15.6,12.5,15.6h44.9 c8.2,0,14.3-7.6,12.5-15.6l-20.4-91.9c6.5-4.6,11.1-11.9,11.1-20.5c0-9.3-5.2-17-12.5-21.5c0.6-12,6.8-22.6,16.6-29.4l156.5,48.1 c7.2,2.2,21.2,5,37.4,0l223.2-68.6C516.7,204.4,516.7,179.6,497.9,173.8L497.9,173.8z M282.2,303.3c-22.8,7-42.3,3.1-52.5,0 l-116-35.6l-11.3,90.8c0,28.3,68.8,51.2,153.6,51.2s153.6-22.9,153.6-51.2l-11.3-90.8L282.2,303.3z"
});

function SvgScholarCap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    focusable: "false",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScholarCap);
export default __webpack_public_path__ + "static/media/scholarCap.f050284e.svg";
export { ForwardRef as ReactComponent };